module.exports = __webpack_public_path__ + "media/images/finger-print/finger-print-img-7838cf06370d961eb3b6eaf117442879.png";